import { makeStyles } from '@material-ui/core/styles';

export const FORM_FIELDS_COLOR = '#DEDEDE';

const useStyles = makeStyles((theme) => ({
  layout: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  submit: {
    backgroundColor: '#024C7A',
    margin: theme.spacing(3, 0, 3),
    padding: '.75rem .5rem',
    width: '100%',
    alignSelf: 'center',
    borderRadius: '24px',
    '&:hover': {
      backgroundColor: '#024C7A',
      opacity: '.9',
    },
    '&:disabled': {
      backgroundColor: '#024C7A99',
    },
  },
  title: {
    marginTop: 10,
    marginBottom: 10,
  },
  // input
  input: {
    color: FORM_FIELDS_COLOR,
  },
  inputLabel: {
    color: FORM_FIELDS_COLOR,
    '&.Mui-focused': {
      color: FORM_FIELDS_COLOR,
    },
  },
  inputLabelFocus: {},
  inputIcon: {
    color: FORM_FIELDS_COLOR,
  },
  notchedOutline: {
    borderWidth: '1px !important',
    borderColor: `${FORM_FIELDS_COLOR} !important`,
    color: `${FORM_FIELDS_COLOR} !important`,
    borderRadius: '25px',
  },
  notchedOutlineFocus: {
    borderWidth: '1px',
    borderColor: `${FORM_FIELDS_COLOR} !important`,
  },
}));

export default useStyles;
